import * as APIBase from './APIBase';

export default class SubscriptionsApi {
  static get() {
    return APIBase.getSubscriptionData();
    // return APIBase.getAPI('https://orchsub.stg.telematicsct.com/subscription/v1/subscription/JTHBE2CL5G7448424', false,
    //   { Accept: '*/*',
    //     'Accept-Encoding': 'deflate',
    //     Authorization: '8923gf7126h44b14d3df08dd9f87a',
    //     'Cache-Control': 'no-cache',
    //     Connection: 'keep-alive',
    //     'Content-Type': 'application/json',
    //     DATETIME: '1511796583386',
    //     Host: 'orchsub.stg.telematicsct.com',
    //     'Postman-Token': 'dd22629e-f3e0-4cc2-94cf-3d9478f499bf,3b6fc641-8850-47db-85de-646146e2472c',
    //     'User-Agent': 'PostmanRuntime/7.16.3',
    //     'X-BRAND': 'T',
    //     'X-CHANNEL': 'US_DEALER',
    //     'X-CORRELATIONID': '63b2e6c4-da0d-424a-8032-fb7f3fe436e3',
    //     'cache-control': 'no-cache' });
  }

  static getStatus() {
    return APIBase.getRemoteStatus();
  //   return APIBase.getAPI('https://orchsub.stg.telematicsct.com/subscription/v1/status/1D4GP23E26B673062/f0a9dcdc36e2494cbe555787cbffd77b', false,
  //     { Accept: '*/*',
  //       'Accept-Encoding': 'deflate',
  //       Authorization: '8923gf7126h44b14d3df08dd9f87a',
  //       'Cache-Control': 'no-cache',
  //       Connection: 'keep-alive',
  //       'Content-Type': 'application/json',
  //       DATETIME: '1511796583386',
  //       Host: 'orchsub.stg.telematicsct.com',
  //       'Postman-Token': 'dd22629e-f3e0-4cc2-94cf-3d9478f499bf,3b6fc641-8850-47db-85de-646146e2472c',
  //       'User-Agent': 'PostmanRuntime/7.16.3',
  //       'X-BRAND': 'T',
  //       'X-CHANNEL': 'US_DEALER',
  //       'X-CORRELATIONID': '63b2e6c4-da0d-424a-8032-fb7f3fe436e3',
  //       'cache-control': 'no-cache' });
  }
}
